import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

import ApraInfo from "../ApraInfo";
import Copyright from "../Copyright";
import SocialIcons from "../SocialIcons";
import Menu from "../Menu";

import MenuAccordionItem from "./MenuAccordionItem";

const { Box, Accordion } = Chakra;

const MobileFooter = ({ menus }) => (
  <>
    <Box px={8} pt={16}>
      <ApraInfo />
      <Menu menu={menus.imprint} />
      <SocialIcons />
    </Box>
    <Accordion allowToggle mt={10} data-testid="mobile-footer-section" borderY="1px" borderColor="greyscale.400">
      <MenuAccordionItem label="menu_our_company" menu={menus.company} />
      <MenuAccordionItem label="menu_know_your_rights" menu={menus.knowYourRights} />
      <MenuAccordionItem label="menu_our_products" menu={menus.products} />
      <MenuAccordionItem label="menu_support" menu={menus.support} />
      <MenuAccordionItem label="menu_other" menu={menus.legal} />
    </Accordion>
    <Box px={8} py={9}>
      <Copyright />
    </Box>
  </>
);

export default MobileFooter;

MobileFooter.propTypes = {
  menus: PropTypes.shape({
    knowYourRights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    support: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    company: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    legal: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    imprint: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};
